import * as React from 'react'
import classnames from 'classnames'
import { ASC, DESC } from '@App/constantes'
import '../style.scss'

const handleColumnSortingClick = (props: any) => {
  const { sorter, header, onSetSorter, colNumber } = props

  const targetColumn = header[colNumber - 1]

  if (targetColumn && sorter.order_by_sort) {
    if (sorter.order_by === targetColumn.alias) {
      onSetSorter(
        targetColumn.alias,
        sorter.order_by_sort === ASC ? DESC : ASC,
      )
    } else {
      onSetSorter(
        targetColumn.alias,
        sorter.order_by_sort === ASC ? DESC : ASC,
      )
    }
  }
}

const TableHeader = (props: any) => {
  const { header, sort, saveSortData, sortData, disableTopBorder } = props

  return (
    <div className={classnames('tableHeader', disableTopBorder ? 'disableTopBorder' : null)}>
      {header.map((headerCell: any, index: any) => {
        return (
          <div
            key={`TABLE__HEADER__CELL--${headerCell.name}--${index}`}
            className={classnames({
              th: true,
              small: headerCell.small,
            })}
          >
            {(headerCell.label || headerCell.name || '')}
            {sort && headerCell.sortable
              && (
                <span
                  role="button"
                  tabIndex={-15}
                  className={classnames(
                    'arrow',
                    sortData.order_by === headerCell.alias
                      && sortData.order_by_sort === ASC ? 'asc' : 'desc',
                  )}
                  onKeyDown={() => {
                  }}
                  onClick={event => handleColumnSortingClick({
                    event,
                    header,
                    colNumber: index + 1,
                    onSetSorter: saveSortData,
                    sorter: sortData,
                  })}
                />
              )
            }
          </div>
        )
      })}
    </div>
  )
}

export default TableHeader
